import parametresDashboard from "./parametresDashboard"
export default parametresDashboard;
